import { render, staticRenderFns } from "./coin.vue?vue&type=template&id=6d34f152&"
import script from "./coin.vue?vue&type=script&lang=js&"
export * from "./coin.vue?vue&type=script&lang=js&"
import style0 from "./coin.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports